import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import Landing from "@/pages/Landing";

function App() {
  useLenis();
  return (
    <div className="App grain">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1C1C1A",
            color: "#F4F3F0",
            border: "1px solid rgba(244,243,240,0.1)",
            borderRadius: "0",
            fontFamily: "Space Mono, monospace",
            fontSize: "13px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
